import { Outlet } from 'react-router-dom';
import { usePageAnalytics } from '../../hooks/usePageAnalytics';

/** No nav, footer, or links — for in-app paywall legal pages only. */
export function MinimalShell() {
  usePageAnalytics();
  return (
    <div style={{ minHeight: '100vh' }}>
      <main>
        <Outlet />
      </main>
    </div>
  );
}
